import { render, staticRenderFns } from "./Punto-Tombo.vue?vue&type=template&id=af624b6a&"
import script from "./Punto-Tombo.vue?vue&type=script&lang=js&"
export * from "./Punto-Tombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports